let language = {
    REGIST_INTRO_TITLE: "QP Partnership Program Registration",
    REGIST_INTRO_1: "Begin your e-commerce business confidently with {{appName}}'s dependable printing service.",
    REGIST_INTRO_2: "Experience the ultimate dropshipping solution for your e-commerce business.",
    REGIST_INTRO_3: "Join the {{appName}} community and turn your ideas into reality.",
};

export { language }